<template>
  <div class="profile-page">
    <header class="profile-header">
      <img v-if="$i18n.locale === 'en'" src="../../static/images/profile/profile.png" :alt="$t('homeProfile')" />
      <h1 v-else>{{ $t('homeProfile') }}</h1>
    </header>

    <main class="profile-card">
      <img class="profile-avatar" src="../../static/images/profile/avatar.png" alt="" />
      <div class="profile-name-row">
        <span class="profile-name">{{ info.nickname || $t('profileDefaultName') }}</span>
        <button class="profile-edit" type="button" :aria-label="$t('Edit')" @click="openNicknameEdit">
          <img src="../../static/images/profile/edit.png" alt="" />
        </button>
      </div>
      <div class="profile-mobile">{{ info.mobile || savedMobile }}</div>

      <section class="profile-languages" :aria-label="$t('profileSelectLanguage')">
        <div class="profile-language-title">{{ $t('profileSelectLanguage') }}</div>
        <button class="profile-language-option" :class="{selected: selectedLang === 'en'}" type="button" @click="selectLanguage('en')">
          <img src="../../static/images/profile/en_flag.png" alt="" />
          <span>{{ $t('profileEnglish') }}</span>
          <strong v-if="selectedLang === 'en'">{{ $t('profileSelected') }}</strong>
        </button>
        <button class="profile-language-option" :class="{selected: selectedLang === 'bur'}" type="button" @click="selectLanguage('bur')">
          <img src="../../static/images/profile/mm_flag.png" alt="" />
          <span>{{ $t('profileMyanmar') }}</span>
          <strong v-if="selectedLang === 'bur'">{{ $t('profileSelected') }}</strong>
        </button>
      </section>

      <nav class="profile-links">
        <button type="button" @click="$router.push({path:'/termsAndCondition2'})">{{ $t('TC') }}</button>
        <button type="button" @click="$router.push({path:'/faq2'})">{{ $t('FAQ') }}</button>
      </nav>

      <button class="profile-unsubscribe" :class="{'is-burmese': selectedLang === 'bur'}" type="button" @click="showUnsubscribeConfirm = true">
        {{ $t('UNSUBSCRIBE') }}
      </button>
    </main>

    <HomeTabBar active="profile" :available="availableBoxes" @select-box="goBoxes" />

    <div v-if="showNicknameEdit" class="profile-confirm-mask" role="presentation" @click.self="closeNicknameEdit">
      <form class="profile-confirm-dialog profile-name-dialog" role="dialog" aria-modal="true" aria-labelledby="profile-name-dialog-title" @submit.prevent="saveNickname">
        <h2 id="profile-name-dialog-title">{{ $t('profileEditName') }}</h2>
        <input ref="nicknameInput" v-model="nicknameDraft" type="text" name="nickname" maxlength="50" :placeholder="$t('profileNamePlaceholder')" :aria-label="$t('profileEditName')" @input="nicknameError = ''" />
        <p v-if="nicknameError" class="profile-name-error">{{ nicknameError }}</p>
        <div class="profile-confirm-actions profile-name-actions">
          <button type="button" :disabled="nicknameSaving" @click="closeNicknameEdit">{{ $t('profileCancel') }}</button>
          <button type="submit" :disabled="nicknameSaving">{{ $t('Save') }}</button>
        </div>
      </form>
    </div>

    <div v-if="showUnsubscribeConfirm" class="profile-confirm-mask" role="presentation" @click.self="showUnsubscribeConfirm = false">
      <div class="profile-confirm-dialog" role="alertdialog" aria-modal="true" :aria-label="$t('profileConfirmTitle')">
        <h2>{{ $t('profileConfirmTitle') }}</h2>
        <p>{{ $t('des2') }}</p>
        <div class="profile-confirm-actions">
          <button type="button" @click="showUnsubscribeConfirm = false">{{ $t('No') }}</button>
          <button type="button" :disabled="unsubscribing" @click="confirmUnsubscribe">{{ $t('Yes') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeTabBar from '../components/HomeTabBar'

export default {
  name: 'Profile',
  components: {HomeTabBar},
  data() {
    return {
      info: {},
      selectedLang: this.$i18n.locale,
      availableBoxes: false,
      showNicknameEdit: false,
      nicknameDraft: '',
      nicknameError: '',
      nicknameSaving: false,
      showUnsubscribeConfirm: false,
      unsubscribing: false
    }
  },
  computed: {
    savedMobile() {
      return localStorage.getItem('mobile') || ''
    }
  },
  created() {
    this.getProfile()
    this.getBoxStatus()
  },
  methods: {
    getProfile() {
      this.$api.post('/api/user/info', null, r => {
        this.$parent.returnCode(r, () => {
          this.info = r.data || {}
        })
      })
    },
    getBoxStatus() {
      this.$api.post('/api/index/index', null, r => {
        if (Number(r.code) === 1 && r.data) {
          this.availableBoxes = Number(r.data.draw_num) > 0
        }
      })
    },
    selectLanguage(lang) {
      if (this.selectedLang === lang) return
      localStorage.setItem('lang', lang)
      this.selectedLang = lang
      this.$i18n.locale = lang
      window.location.reload()
    },
    goBoxes() {
      this.$router.push({path: '/'})
    },
    openNicknameEdit() {
      this.nicknameDraft = this.info.nickname || ''
      this.nicknameError = ''
      this.showNicknameEdit = true
      this.$nextTick(() => this.$refs.nicknameInput.focus())
    },
    closeNicknameEdit() {
      if (this.nicknameSaving) return
      this.showNicknameEdit = false
    },
    saveNickname() {
      if (this.nicknameSaving) return
      const nickname = this.nicknameDraft.trim()
      if (!nickname) {
        this.nicknameError = this.$t('profileNameRequired')
        return
      }
      this.nicknameSaving = true
      this.$api.post('/api/user/profile', {nickname}, r => {
        this.nicknameSaving = false
        if (Number(r.code) === 1) {
          this.$set(this.info, 'nickname', nickname)
          this.showNicknameEdit = false
          this.$utils.alertText(r.msg, 80, 3000)
        } else {
          this.$parent.returnCode(r, () => {})
        }
      })
    },
    confirmUnsubscribe() {
      if (this.unsubscribing) return
      this.unsubscribing = true
      this.$parent.loadModal(true)
      this.$api.post('/api/user/unsubscribe', null, r => {
        this.$parent.loadModal(false)
        this.unsubscribing = false
        this.$utils.alertText(r.msg, 80, 3000)
        if (Number(r.code) === 1) {
          localStorage.removeItem('token')
          localStorage.removeItem('mobile')
          window.location.href = '/'
        } else {
          this.showUnsubscribeConfirm = false
        }
      })
    }
  }
}
</script>

<style scoped>
.profile-page {
  width: 100%;
  min-height: 100vh;
  padding: 0.25rem 0 2.3rem;
  background: #080e36 url(../../static/images/index/main_bg.jpg) no-repeat center top;
  background-size: 100% 100%;
  color: #fff;
  font-family: Atom-sans;
}

.profile-header {
  height: 1.44rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.35rem;
}

.profile-header img {
  display: block;
  width: 3.6rem;
  height: auto;
}

.profile-header h1 {
  max-width: 5.8rem;
  margin: 0;
  font-family: Atom-sans-bold;
  font-size: 0.56rem;
  text-align: center;
  text-shadow: 0 0 0.25rem #8551ff;
}

.profile-card {
  position: relative;
  width: 90.8%;
  max-width: 6.81rem;
  aspect-ratio: 1021 / 1465;
  margin: 1.4rem auto 0;
  background: url(../../static/images/profile/profile_bg.png) no-repeat center;
  background-size: 100% 100%;
}

.profile-avatar {
  position: absolute;
  top: -1.05rem;
  left: 50%;
  display: block;
  width: 2.16rem;
  height: 2.16rem;
  transform: translateX(-50%);
}

.profile-name-row {
  position: absolute;
  top: 1.48rem;
  left: 6%;
  width: 88%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.12rem;
}

.profile-name {
  max-width: 75%;
  overflow: hidden;
  font-family: Atom-sans-bold;
  font-size: 0.38rem;
  line-height: 1.1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-edit {
  width: 0.34rem;
  height: 0.34rem;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
}

.profile-edit img {
  display: block;
  width: 100%;
  height: 100%;
}

.profile-mobile {
  position: absolute;
  top: 2.12rem;
  left: 5%;
  width: 90%;
  color: #18eaf0;
  font-family: Atom-sans-bold;
  font-size: 0.34rem;
  text-align: center;
}

.profile-languages {
  position: absolute;
  top: 2.93rem;
  left: 50%;
  width: 90%;
  aspect-ratio: 920 / 500;
  background: url(../../static/images/profile/language_select_bg.png) no-repeat center;
  background-size: 100% 100%;
  transform: translateX(-50%);
}

.profile-language-title {
  position: absolute;
  top: 0;
  left: 50%;
  width: 55%;
  height: 0.54rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.08rem;
  background: url(../../static/images/profile/select_language_title_bg.png) no-repeat center;
  background-size: 100% 100%;
  font-family: Atom-sans-bold;
  font-size: 0.27rem;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  transform: translateX(-50%);
}

.profile-language-option {
  position: absolute;
  left: 3.5%;
  width: 93%;
  height: 0.94rem;
  display: flex;
  align-items: center;
  gap: 0.2rem;
  padding: 0.07rem 0.18rem 0.07rem 0.08rem;
  border: 0;
  background: url(../../static/images/profile/language.png) no-repeat center;
  background-size: 100% 100%;
  color: #fff;
  font-family: Atom-sans;
  font-size: 0.28rem;
  text-align: left;
  cursor: pointer;
}

.profile-language-option:nth-of-type(1) {
  top: 0.87rem;
}

.profile-language-option:nth-of-type(2) {
  top: 1.99rem;
}

.profile-language-option.selected {
  background-image: url(../../static/images/profile/language_select.png);
}

.profile-language-option img {
  flex: 0 0 0.74rem;
  width: 0.74rem;
  height: 0.74rem;
}

.profile-language-option span {
  flex: 1;
}

.profile-language-option strong {
  color: #a6ff38;
  font-size: 0.23rem;
  font-weight: normal;
}

.profile-links {
  position: absolute;
  top: 6.48rem;
  left: 50%;
  width: 90%;
  aspect-ratio: 920 / 190;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.22rem;
  background: url(../../static/images/profile/faq_tc_bg.png) no-repeat center;
  background-size: 100% 100%;
  transform: translateX(-50%);
}

.profile-links button {
  width: 44.5%;
  height: 0.79rem;
  padding: 0 0.1rem;
  border: 0;
  background: url(../../static/images/profile/faq_tc_btn_bg.png) no-repeat center;
  background-size: 100% 100%;
  color: #fff;
  font-family: Atom-sans-bold;
  font-size: 0.32rem;
  cursor: pointer;
}

.profile-unsubscribe {
  position: absolute;
  top: 8.04rem;
  left: 50%;
  width: 3.45rem;
  height: 1.31rem;
  padding: 0 0.2rem;
  border: 0;
  background: url(../../static/images/profile/unsub_btn_bg.png) no-repeat center;
  background-size: 100% 100%;
  color: #fff;
  font-family: Atom-sans-bold;
  font-size: 0.32rem;
  font-style: italic;
  white-space: nowrap;
  transform: translateX(-50%);
  cursor: pointer;
}

.profile-unsubscribe.is-burmese {
  font-size: 0.22rem;
  line-height: 1.1;
  white-space: normal;
}

.profile-confirm-mask {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem;
  background: rgba(0, 4, 30, 0.75);
}

.profile-confirm-dialog {
  width: 100%;
  max-width: 6.2rem;
  padding: 0.42rem 0.35rem;
  border: 0.03rem solid #42bde9;
  border-radius: 0.28rem;
  background: #0b1247;
  text-align: center;
}

.profile-confirm-dialog h2 {
  margin: 0 0 0.24rem;
  font-family: Atom-sans-bold;
  font-size: 0.36rem;
}

.profile-confirm-dialog p {
  margin: 0 0 0.42rem;
  font-size: 0.28rem;
  line-height: 1.4;
}

.profile-name-dialog input {
  display: block;
  width: 100%;
  height: 0.84rem;
  margin: 0.1rem 0 0.36rem;
  padding: 0 0.22rem;
  border: 0.02rem solid #4b70f5;
  border-radius: 0.18rem;
  background: #070c32;
  color: #fff;
  font-family: Atom-sans;
  font-size: 0.31rem;
}

.profile-name-dialog input:focus {
  border-color: #1feaf0;
}

.profile-name-dialog input::placeholder {
  color: #a1a8d4;
  font-size: 0.25rem;
}

.profile-name-dialog .profile-name-error {
  margin: -0.2rem 0 0.3rem;
  color: #ff759a;
}

.profile-confirm-actions {
  display: flex;
  gap: 0.18rem;
}

.profile-confirm-actions button {
  flex: 1;
  min-height: 0.78rem;
  padding: 0.1rem;
  border: 0;
  border-radius: 0.42rem;
  background: #3655ff url(../../static/images/profile/faq_tc_btn_bg.png) no-repeat center;
  background-size: 100% 100%;
  color: #fff;
  font-family: Atom-sans-bold;
  font-size: 0.27rem;
  cursor: pointer;
}

.profile-confirm-actions button:last-child {
  background: #ea1e57 url(../../static/images/profile/unsub_btn_bg.png) no-repeat center;
  background-size: 100% 100%;
}

.profile-name-actions button:last-child {
  background: #3655ff url(../../static/images/profile/faq_tc_btn_bg.png) no-repeat center;
  background-size: 100% 100%;
}

.profile-confirm-actions button:disabled {
  opacity: 0.6;
  cursor: default;
}

@media (min-width: 481px) {
  .profile-page {
    box-shadow: 0 0 0 100vmax #0d123b;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/profile.vue